import moment from "moment";
import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Grid, withStyles, Typography, Divider } from "@material-ui/core";

import {
  getDashboardStatsFromState,
  getDashboardModalEmployeesFromState,
} from "features/planner/report/report.selectors";

import { Format } from "app/app.constants";
import BasePage from "app/components/BasePage";
import { formatDate } from "utils/format.util";
import { getSummarizedDataStatesFromState } from "app/app.selectors";
import { ACTIONS } from "features/planner/report/report.constants";
import { dashboardOnLoad } from "features/planner/report/report.actions";
import { DASHBOARD_EMPLOYEES_MODAL } from "features/planner/planner.constants";
import DashboardEmployeesModal from "features/planner/report/dashboard/components/DashboardEmployeesModal";
import DeploymentsDashboardSection from "features/planner/report/dashboard/sections/DeploymentsDashboardSection";
import PersonnelAvailableDashboardSection from "features/planner/report/dashboard/sections/PersonnelAvailableDashboardSection";
import WorkScheduleOverrideDashboardSection from "features/planner/report/dashboard/sections/WorkScheduleOverrideDashboardSection";

const DASHBOARD_INTERVAL_SECONDS = 30;

class DashboardContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      intervalId: null,
      lastUpdated: null,
      modalTitle: null,
    };
  }

  componentDidMount() {
    this.setState({
      intervalId: this.getDashboardStats().then(() =>
        setInterval(this.getDashboardStats, DASHBOARD_INTERVAL_SECONDS * 1000),
      ),
    });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  getDashboardStats = () => {
    const { dataState, dispatchGetDashboardOnLoad } = this.props;

    if (dataState.isLoading()) return Promise.resolve();

    return dispatchGetDashboardOnLoad().then(() =>
      this.setState({
        lastUpdated: moment(),
      }),
    );
  };

  setModalTitle = title =>
    this.setState({
      modalTitle: title,
    });

  render() {
    const { dataState, stats, classes, modalEmployees } = this.props;

    return (
      <BasePage
        dataState={dataState}
        title={
          <Grid
            xs
            item
            container
            wrap="nowrap"
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item />
            <Grid item>
              <Typography variant="caption">Last updated:</Typography>
              &nbsp;
              <Typography variant="caption">
                <b>{formatDate(this.state.lastUpdated, Format.dashboard)}</b>
              </Typography>
            </Grid>
          </Grid>
        }
      >
        <Grid container spacing={6} alignItems="baseline">
          <Grid container item md={6}>
            <Grid item xs={12} className={classes.statsRow}>
              <PersonnelAvailableDashboardSection
                stats={stats}
                setModalTitle={this.setModalTitle}
              />
            </Grid>

            <Grid container component={Divider} className={classes.divider} />

            <Grid item xs={12}>
              <WorkScheduleOverrideDashboardSection stats={stats} />
            </Grid>
          </Grid>

          <Grid container item md={6}>
            <Grid item xs={12}>
              <DeploymentsDashboardSection
                stats={stats}
                setModalTitle={this.setModalTitle}
              />
            </Grid>
          </Grid>
        </Grid>
        <DashboardEmployeesModal
          employees={modalEmployees}
          title={this.state.modalTitle}
          modalId={DASHBOARD_EMPLOYEES_MODAL}
        />
      </BasePage>
    );
  }
}

const styles = theme => ({
  statsRow: {
    marginBottom: theme.spacing(4),
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
});

export default compose(
  connect(
    state => ({
      modalEmployees: getDashboardModalEmployeesFromState(state),
      stats: getDashboardStatsFromState(state),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_DASHBOARD_REPORT_STATS,
        ACTIONS.GET_WORK_SCHEDULE_OVERRIDE_TIMESERIES,
      ),
    }),
    {
      dispatchGetDashboardOnLoad: dashboardOnLoad,
    },
  ),
  withStyles(styles),
)(DashboardContainer);
